import type { people } from "@herefor/contracts";
import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";

/** The one purpose-built reactive subscription behind the read-only plan surfaces. */
export const livePlanQuery = api.domain.plan.read;

/** Inferred from generated Convex types so the browser cannot drift from the backend. */
export type LivePlanResult = FunctionReturnType<typeof livePlanQuery>;

/**
 * The supported person, as the browser receives her.
 *
 * THE CONSUMER TYPECHECK (bead hf-86o, the hf-re6 pattern). The server's resolver
 * already `satisfies` `people.SupportedPersonView`, which stops the backend drifting
 * from the contract. This closes the other half of the loop: the shape the BROWSER
 * infers from the generated API has to remain assignable to the same contract, so a
 * field quietly dropped on its way through Convex fails `pnpm turbo typecheck` here
 * rather than at whichever surface happened to render it.
 *
 * `isPlaceholder` is the field this is really guarding. It is the one every consumer
 * can render without and none should (D-091).
 */
export type SupportedPersonView = NonNullable<LivePlanResult["supportedPerson"]>;

/** Compile-time only: `A` must be assignable to `B`, or this alias will not resolve. */
type AssignableTo<A extends B, B> = A;

export type SupportedPersonMatchesContract = AssignableTo<
  SupportedPersonView,
  people.SupportedPersonView
>;
